import { render, staticRenderFns } from "./IndexGoodsList.vue?vue&type=template&id=cbd07394&scoped=true&lang=pug&"
import script from "./IndexGoodsList.vue?vue&type=script&lang=ts&"
export * from "./IndexGoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./IndexGoodsList.vue?vue&type=style&index=0&id=cbd07394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd07394",
  null
  
)

export default component.exports